import axios from 'axios';
import { apiConfig } from '../config/api.config';

// 创建axios实例
const instance = axios.create({
  baseURL: apiConfig.host
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 添加跨域请求头
    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
    config.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, Accept, Authorization, X-Request-With';
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export default instance;